import type { FirebaseOptions } from "firebase/app";

/**
 * Firebase 웹 설정 — 코드 상수 금지(no-hardcode), `VITE_FIREBASE_*` 환경변수에서 읽는다.
 * 필수 키(apiKey/projectId/appId) 미설정 시 `null` → 앱은 클라우드 없이 로컬 단독 세이브로 graceful fallback.
 * 실제 값은 `.env.local`(gitignore)이나 빌드 env로 주입. `.env.example` 템플릿 참고.
 */
export function readFirebaseEnv(): FirebaseOptions | null {
  const env = import.meta.env as Record<string, string | undefined>;
  const apiKey = env["VITE_FIREBASE_API_KEY"];
  const projectId = env["VITE_FIREBASE_PROJECT_ID"];
  const appId = env["VITE_FIREBASE_APP_ID"];
  if (!apiKey || !projectId || !appId) return null;
  return {
    apiKey,
    authDomain: env["VITE_FIREBASE_AUTH_DOMAIN"] ?? `${projectId}.firebaseapp.com`,
    projectId,
    storageBucket: env["VITE_FIREBASE_STORAGE_BUCKET"] ?? `${projectId}.appspot.com`,
    messagingSenderId: env["VITE_FIREBASE_MESSAGING_SENDER_ID"],
    appId,
    measurementId: env["VITE_FIREBASE_MEASUREMENT_ID"],
  };
}
